import { render, staticRenderFns } from "./EventHandlerList.vue?vue&type=template&id=48e8b3b5&"
import script from "./EventHandlerList.vue?vue&type=script&lang=js&"
export * from "./EventHandlerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports